import { Factory } from '../Factory';
import { Service } from '../Service';
import { IConfigService } from '../config';
import { IHttpWrapperService } from '../http';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';
import { INotificationService } from '../notification';

export class BatchService extends Service<any> {
  private configService: IConfigService;
  private httpService: IHttpWrapperService;

    constructor(resource: angular.resource.IResourceService, rootScope: IRootScope, configService: IConfigService, resourceWrapperService: ResourceWrapperService, httpService: IHttpWrapperService, private notificationService: INotificationService) {
      super({resource, rootScope, resourceWrapperService});

      this.configService = configService;
      this.httpService = httpService;

      let raw = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/batch/:id`,
        {id: "@id", projectId: "@projectId"},
        {
          update: {method: "PUT"},
          query: {method: "GET", params: {page: 1, limit: 50}, isArray: false}
        }
      );

      this.itemResource = this.resourceWrapperService.WrapActions(raw);

      // BatchingComplete is handled in React
      // (src/hooks/useProjectBatches -> WebSocketBridge), including its toast.
    }

    public Assign(project: any, batch: Batch): ng.IPromise<boolean> {
      return this.httpService.$http({
        method: 'POST',
        url: `${this.configService.getServerBaseUrl()}/project/${project.id}/batch/assign`,
        data: batch
      });
    }

    public GetAll(projectId: string, page: number, limit: number, assignedOnly: boolean = false) {
      return this.itemResource.query({
        projectId: projectId,
        page: page,
        limit: limit,
        assignedOnly
      }).$promise;
    }

  }

frontendApp.factory("BatchService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "HttpService", "NotificationService", Factory.Create(BatchService)]);
